import React from 'react';
import { exportTableToExcel, exportTableToPdf } from '../../utils/tableExport';
import './TableExportActions.css';

const TableExportActions = ({
  tableRef = null,
  tableSelector = '',
  columns = [],
  rows = [],
  fileName = 'grilla',
  title = 'Exportación de grilla',
  className = '',
  compact = false,
  disabled = undefined
}) => {
  const buildPayload = () => {
    const tableElement = tableRef?.current || (tableSelector ? document.querySelector(tableSelector) : null);

    if (tableElement) {
      return {
        tableElement,
        fileName,
        title
      };
    }

    return {
      columns,
      rows,
      fileName,
      title
    };
  };

  const resolvedTableElement = tableRef?.current || (tableSelector ? document.querySelector(tableSelector) : null);
  const hasData = resolvedTableElement
    ? Boolean(resolvedTableElement.querySelector('tbody tr'))
    : Array.isArray(rows) && rows.length > 0 && Array.isArray(columns) && columns.length > 0;

  const isDisabled = typeof disabled === 'boolean' ? disabled : !hasData;

  return (
    <div className={`table-export-actions ${compact ? 'compact' : ''} ${className}`.trim()}>
      <button
        type="button"
        className="table-export-btn excel"
        onClick={() => exportTableToExcel(buildPayload())}
        disabled={isDisabled}
        title="Descargar Excel"
      >
        <i className="fas fa-file-excel" />
        <span>Excel</span>
      </button>
      <button
        type="button"
        className="table-export-btn pdf"
        onClick={() => exportTableToPdf(buildPayload())}
        disabled={isDisabled}
        title="Descargar PDF"
      >
        <i className="fas fa-file-pdf" />
        <span>PDF</span>
      </button>
    </div>
  );
};

export default TableExportActions;
